import React, { useState } from "react";
import case_under from "../../images/case_under.png";
import phone from "../../images/phone-flip.png";
import case_picture from "../../images/case-img-main.png";
import united_logo from "../../images/united-logo.png";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import { Route, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
const CvUpload = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    resume: null,
    userPhoto: null,
  });
  const route = useParams();
  const inputStyle = {
    width: "100%",
    borderBottom: "1px solid #B5B5B6",
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    padding: "8px 8px 8px 0",
    textAlign: "left",
  };

  const fileInputContainerStyle = {
    borderBottom: "1px solid #B5B5B6",
    paddingBottom: ".5rem",
    width: "97%",
  };

  const fileInputStyle = {
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    textAlign: "left",
  };

  const submitButtonStyle = {
    fontSize: "16px",
    width: "118px",
    height: "43px",
    backgroundColor: "#0C807D",
    color: "#fff",
    textTransform: "capitalize",
    border: "none",
    borderRadius: "6px",
    fontWeight: 500,
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("type", "career_form");
    body.append("job_id", route.id);
    body.append("first_name", formData.firstName);
    body.append("last_name", formData.lastName);
    body.append("email", formData.email);
    body.append("department", "");
    body.append("expected_salary", "");
    body.append("cover_letter", "");
    body.append("status", "1");
    body.append("resume", formData.resume);
    body.append("user_photo", formData.userPhoto);
    try {
      const req = scAxiosAdmin
        .post(`/job_applications`, body, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        })
        .then((data) => {
          if (data.status === 201) {
            toast.success("Application Submitted Successfully");
          }
        })
        .catch((e) => {
          toast.error("Something went wrong!");
        });
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  return (
    <div>
      <Seo
        title="Death Certificate | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Death Certificate"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <section className="banner-hero">
          <img
            src="/assets/images/banner-case-study.png"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section class="container  pb-4">
          <div className="d-flex flex-column justify-content-between align-items-center p-4">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <h3
                className="text-center"
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                Upload Your CV
              </h3>
              <img
                width={103}
                height={2}
                src="/assets/images/doctor_under.png"
                alt=""
              />
            </div>
          </div>
          <div
            class="row pt-5 pb-5 border justify-content-md-between"
            style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }}
          >
            <div class="col-12 d-flex">
              <form onSubmit={handleSubmit}>
                <div className="row p-3 g-5 justify-content-around w-100">
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="First Name"
                      autoComplete="off"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Last Name"
                      autoComplete="off"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      placeholder="Email Address"
                      autoComplete="off"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      placeholder="Phone Number"
                      autoComplete="off"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                  </div>
                  <div
                    className="col-md-12 px-0"
                    style={fileInputContainerStyle}
                  >
                    <div className="d-flex justify-content-between align-items-end flex-row w-100">
                      <p>Upload Image</p>
                      <input
                        className="w-100"
                        type="file"
                        name="userPhoto"
                        onChange={handleChange}
                        style={fileInputStyle}
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-12 px-0"
                    style={fileInputContainerStyle}
                  >
                    <div className="d-flex justify-content-between align-items-end flex-row w-100">
                      <p>Resume/CV</p>
                      <input
                        className="w-100"
                        type="file"
                        name="resume"
                        onChange={handleChange}
                        style={fileInputStyle}
                      />
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                    <button type="submit" style={submitButtonStyle}>
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CvUpload;



// WEBPACK FOOTER //
// ./src/component/frontend/CvUpload.js